import InboxesAdmin from 'models/location/inboxes_admin';
import OpenInboxesAdmin from 'actions/routing_groups/open_inboxes_admin';
import { registerUrlConverter } from './location_url';
import StaticUrlConverter from './url_converters/static_url_converter';
import UnloadRoutingGroupAdmin from 'actions/routing_groups/unload_routing_group_admin';

registerUrlConverter(InboxesAdmin, StaticUrlConverter.create('/inboxes'));

export default function(router, { runnerContext }) {
  return {
    on() {
      runnerContext.executeAction(OpenInboxesAdmin);
    },

    after() {
      runnerContext.executeAction(UnloadRoutingGroupAdmin);
    },
  };
}



// WEBPACK FOOTER //
// ./src/scripts/adapters/routes/routing_groups_routes.js